'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCreateMeetingBodyData = exports.getCreateMeetingQueryParams = exports.getFetchAvailabilityQueryParams = exports.getEmbedded = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reselect = require('reselect');

var _get = require('transmute/get');

var _get2 = _interopRequireDefault(_get);

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _utils = require('MeetingsLib/utils/utils');

var _analytics = require('MeetingsLib/utils/analytics');

var _enums = require('MeetingsBase/constants/enums');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getCurrentTime = (0, _get2.default)('currentTime');
var getEmbedded = exports.getEmbedded = (0, _get2.default)('embedded');
var getParentPageHSAnalyticsInfo = (0, _get2.default)('parentPageHSAnalyticsInfo');

function getUtkToPass(embedded, parentPageHSAnalyticsInfo) {
  if (!parentPageHSAnalyticsInfo) {
    return (0, _analytics.getHubSpotUtk)();
  }
  var parentHubspotUtk = parentPageHSAnalyticsInfo.parentHubspotUtk;

  return embedded && parentHubspotUtk ? parentHubspotUtk : (0, _analytics.getHubSpotUtk)();
}

function addParentCosPageUrl(params, parentPageHSAnalyticsInfo) {
  if (!parentPageHSAnalyticsInfo) {
    return params;
  }
  var parentCosPageUrl = parentPageHSAnalyticsInfo.parentPageUrl;
  if (parentCosPageUrl) {
    return _extends({}, params, {
      parentCosPageUrl: parentCosPageUrl
    });
  }
  return params;
}

var getFetchAvailabilityQueryParams = exports.getFetchAvailabilityQueryParams = function getFetchAvailabilityQueryParams(params) {
  return (0, _reselect.createSelector)([getCurrentTime, getEmbedded, getParentPageHSAnalyticsInfo], function (now, embedded, parentPageHSAnalyticsInfo) {
    var requestParams = {
      now: now,
      includeInactiveLink: (0, _utils.shouldIncludeDeleted)(params),
      hubspotUtk: getUtkToPass(embedded, parentPageHSAnalyticsInfo),
      location: window.location.host
    };
    requestParams = addParentCosPageUrl(requestParams, parentPageHSAnalyticsInfo);
    var email = (0, _get2.default)('email', params);
    if (email) {
      requestParams = _extends({}, requestParams, {
        email: email
      });
    }
    return requestParams;
  });
};

var getCreateMeetingQueryParams = exports.getCreateMeetingQueryParams = function getCreateMeetingQueryParams(state) {
  var trackingParams = state.trackingParams,
      embedded = state.embedded,
      parentPageHSAnalyticsInfo = state.parentPageHSAnalyticsInfo;

  var utk = getUtkToPass(embedded, parentPageHSAnalyticsInfo);
  var requestParams = _extends({}, trackingParams.compact(), {
    hubspotUtk: utk
  });
  requestParams = addParentCosPageUrl(requestParams, parentPageHSAnalyticsInfo);
  return requestParams;
};

var getCreateMeetingBodyData = exports.getCreateMeetingBodyData = function getCreateMeetingBodyData(_ref) {
  var duration = _ref.duration,
      dateTime = _ref.dateTime;
  return function (state) {
    var event = state.bookingLifecycle.event,
        _state$bookInfo = state.bookInfo,
        offline = _state$bookInfo.offline,
        allUsersBusyTimes = _state$bookInfo.allUsersBusyTimes,
        linkType = _state$bookInfo.linkType,
        bufferTime = _state$bookInfo.bufferTime,
        legalConsentEnabled = _state$bookInfo.customParams.legalConsentEnabled,
        legalConsentResponses = state.legalConsentResponses,
        userTimezone = state.userTimezone,
        formState = state.formState;


    var formFields = (0, _utils.formatCustomFormFields)(formState.customFormFields);

    var body = {
      firstName: formState.firstName,
      lastName: formState.lastName,
      email: formState.email,
      formFields: formFields,
      offline: offline,
      locale: _I18n2.default.locale,
      timezone: userTimezone,
      duration: duration,
      startTime: dateTime
    };

    if (legalConsentEnabled) {
      body.legalConsentResponses = legalConsentResponses.toJS();
    }

    if (linkType === _enums.LINK_TYPES.get(_enums.MEETING_TYPES.ROUND_ROBIN)) {
      body.likelyAvailableUserId = (0, _utils.getRoundRobinUserIdToBook)(event, allUsersBusyTimes, bufferTime);
    }

    return body;
  };
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsLib/target/src/MeetingsLib/static-2.875/js/selectors/RESTParamSelectors.js
// module id = 192
// module chunks = 0